/**
 * Template registry — `(template_key, version) → TemplateModule`.
 *
 * The DB knows which template versions exist; the registry knows what
 * each version actually IS (its component + variable schema). A contract
 * row pinned to `template_version_id` resolves the version's
 * `(template_key, version)` from the DB and the registry returns the
 * module to render or build the editor.
 *
 * **Adding a template version is a code change.** Bump v1 → v2 by adding
 * a new module + adding the entry to this map; the schema migration is
 * just an INSERT into `template_versions`. Old contracts pinned to v1
 * keep rendering with the v1 module; they never silently inherit v2.
 */
import * as bostadshyraV1 from './templates/bostadshyra/v1/index.js';
import * as blockhyraV1 from './templates/blockhyra/v1/index.js';
import * as lokalhyraV1 from './templates/lokalhyra/v1/index.js';
import * as bilplatsV1 from './templates/bilplats/v1/index.js';
import * as forhandlingsordning2PartV1 from './templates/forhandlingsordning_2part/v1/index.js';
import * as forhandlingsordning3PartV1 from './templates/forhandlingsordning_3part/v1/index.js';
import * as forhandlingsoverenskommelse2PartV1 from './templates/forhandlingsoverenskommelse_2part/v1/index.js';
import * as forhandlingsoverenskommelse3PartV1 from './templates/forhandlingsoverenskommelse_3part/v1/index.js';
import * as meddelande18eV1 from './templates/meddelande_18e/v1/index.js';
import * as godkannande18dV1 from './templates/godkannande_18d/v1/index.js';
import * as ansokanAndrahandV1 from './templates/ansokan_andrahand/v1/index.js';
import * as evakueringV1 from './templates/evakuering/v1/index.js';
import * as indexavtalV1 from './templates/indexavtal/v1/index.js';
import * as avstaendeBesittningsskyddBostadV1 from './templates/avstaende_besittningsskydd_bostad/v1/index.js';
import * as avstaendeBesittningsskyddLokalV1 from './templates/avstaende_besittningsskydd_lokal/v1/index.js';
import * as andringHyresvillkorV1 from './templates/andring_hyresvillkor/v1/index.js';
import * as andringHyresvillkorForhandlingsklausulV1 from './templates/andring_hyresvillkor_forhandlingsklausul/v1/index.js';
import * as garageV1 from './templates/garage/v1/index.js';
import * as studentbostadV1 from './templates/studentbostad/v1/index.js';
import * as tillaggsavtalHyresgastanpassningV1 from './templates/tillaggsavtal_hyresgastanpassning/v1/index.js';
import * as personuppgiftsbilagaV1 from './templates/personuppgiftsbilaga/v1/index.js';
import * as personuppgiftsavtalV1 from './templates/personuppgiftsavtal/v1/index.js';
import * as villkorsandring54aV1 from './templates/villkorsandring_54a/v1/index.js';
import * as uppsagningVillkorsandringLokalV1 from './templates/uppsagning_villkorsandring_lokal/v1/index.js';
import * as forhandlingsframstallningV1 from './templates/forhandlingsframstallning/v1/index.js';
import * as strandningsmeddelandeV1 from './templates/strandningsmeddelande/v1/index.js';
import * as tillaggsavtalTidsbestamdHyraV1 from './templates/tillaggsavtal_tidsbestamd_hyra/v1/index.js';
import * as samtyckeSarskildaBilagaV1 from './templates/samtycke_sarskilda_bilaga/v1/index.js';
import * as samtyckeSarskildaAvtalV1 from './templates/samtycke_sarskilda_avtal/v1/index.js';
import * as uppsagningAvflyttningLokalV1 from './templates/uppsagning_avflyttning_lokal/v1/index.js';
import * as cleanBilagaV1 from './templates/clean_bilaga/v1/index.js';
import * as lagenhetsforteckningV1 from './templates/lagenhetsforteckning/v1/index.js';
import * as cleanTillaggBostadV1 from './templates/clean_tillagg_bostad/v1/index.js';
import * as cleanTillaggLokalV1 from './templates/clean_tillagg_lokal/v1/index.js';
export const TEMPLATE_REGISTRY = {
    bostadshyra: {
        v1: bostadshyraV1,
    },
    blockhyra: {
        v1: blockhyraV1,
    },
    lokalhyra: {
        v1: lokalhyraV1,
    },
    bilplats: {
        v1: bilplatsV1,
    },
    forhandlingsordning_2part: {
        v1: forhandlingsordning2PartV1,
    },
    forhandlingsordning_3part: {
        v1: forhandlingsordning3PartV1,
    },
    forhandlingsoverenskommelse_2part: {
        v1: forhandlingsoverenskommelse2PartV1,
    },
    forhandlingsoverenskommelse_3part: {
        v1: forhandlingsoverenskommelse3PartV1,
    },
    meddelande_18e: {
        v1: meddelande18eV1,
    },
    godkannande_18d: {
        v1: godkannande18dV1,
    },
    ansokan_andrahand: {
        v1: ansokanAndrahandV1,
    },
    evakuering: {
        v1: evakueringV1,
    },
    indexavtal: {
        v1: indexavtalV1,
    },
    avstaende_besittningsskydd_bostad: {
        v1: avstaendeBesittningsskyddBostadV1,
    },
    avstaende_besittningsskydd_lokal: {
        v1: avstaendeBesittningsskyddLokalV1,
    },
    andring_hyresvillkor: {
        v1: andringHyresvillkorV1,
    },
    andring_hyresvillkor_forhandlingsklausul: {
        v1: andringHyresvillkorForhandlingsklausulV1,
    },
    garage: {
        v1: garageV1,
    },
    studentbostad: {
        v1: studentbostadV1,
    },
    tillaggsavtal_hyresgastanpassning: {
        v1: tillaggsavtalHyresgastanpassningV1,
    },
    personuppgiftsbilaga: {
        v1: personuppgiftsbilagaV1,
    },
    personuppgiftsavtal: {
        v1: personuppgiftsavtalV1,
    },
    villkorsandring_54a: {
        v1: villkorsandring54aV1,
    },
    uppsagning_villkorsandring_lokal: {
        v1: uppsagningVillkorsandringLokalV1,
    },
    forhandlingsframstallning: {
        v1: forhandlingsframstallningV1,
    },
    strandningsmeddelande: {
        v1: strandningsmeddelandeV1,
    },
    tillaggsavtal_tidsbestamd_hyra: {
        v1: tillaggsavtalTidsbestamdHyraV1,
    },
    samtycke_sarskilda_bilaga: {
        v1: samtyckeSarskildaBilagaV1,
    },
    samtycke_sarskilda_avtal: {
        v1: samtyckeSarskildaAvtalV1,
    },
    uppsagning_avflyttning_lokal: {
        v1: uppsagningAvflyttningLokalV1,
    },
    clean_bilaga: {
        v1: cleanBilagaV1,
    },
    lagenhetsforteckning: {
        v1: lagenhetsforteckningV1,
    },
    clean_tillagg_bostad: {
        v1: cleanTillaggBostadV1,
    },
    clean_tillagg_lokal: {
        v1: cleanTillaggLokalV1,
    },
};
export function getTemplateVersion(key, version) {
    const t = TEMPLATE_REGISTRY[key];
    if (!t)
        return null;
    return t[version] ?? null;
}
/**
 * All registered template/version pairs. Used by the dev seed to
 * idempotently insert rows into `templates` + `template_versions`.
 */
export function listAllVersions() {
    const out = [];
    for (const [key, versions] of Object.entries(TEMPLATE_REGISTRY)) {
        for (const [version, mod] of Object.entries(versions)) {
            out.push({ key, version, metadata: mod.metadata });
        }
    }
    return out;
}
//# sourceMappingURL=registry.js.map